export const ProductType = Object.freeze({
  CUT: "cut",
  POT: "pot"
})

export const ProductTypes = ['pot', 'cut']